import axios from '../api'

const getGroupAccountInfo = (params) => axios({ url: `/eos/coupon/group/getGroupAccountInfo`, params })
const getRechargeRecords = (params) => axios({ url: `/eos/coupon/fund/listRechargeRecord`, params })
export default {
  getGroupAccountInfo,
  getRechargeRecords
}
